<template>
  <div>
    <van-cell-group>
      <van-field
        v-model.trim="card"
        placeholder="请输入身份证号"
        clearable
        maxlength="18"
        :formatter="$util.toString"
      />
    </van-cell-group>
    <p class="note">
      为向您添加的就诊人提供预约挂号、问诊服务，您需要向我们提供该就诊人的身份证号码，并确保在提供前已取得该就诊人的授权同意；若该就诊人为儿童的，您需在提供前征得该儿童监护人的同意。
    </p>
    <br />
    <van-button color="#1E8DFF" block :disabled="!card" class="width-351" @click="save">保 存</van-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'EditIdCard',
  // props: {},
  data() {
    return {
      card: ''
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    'userInfo.card': {
      handler(val) {
        this.card = val;
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    save() {
      let params = {
        card: this.card
      };
      // if (!this.$util.isIdCardValid(this.card)) {
      //   this.$toast('请输入正确身份证号码');
      //   return;
      // }

      this.$fetch.fetchModifyUserInfo(params).then(() => {
        this.getUserInfo();
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style scoped>
.note {
  margin: 16px 12px 0;
  color: rgba(204, 204, 204, 1);
  line-height: 20px;
}
</style>
